import { BrowserRouter,Routes, Route, createBrowserRouter, RouterProvider } from 'react-router-dom';
import Mobile from './components/Mobile';
import Feedback from './components/Feedback';
import BranchFeedback from './components/BranchFeedback';
import Otp from './components/Otp';
import QR from './components/QR';
import ThankYou from './components/ThankYou';
import EmployeeCode from './components/employeeCode';
import SalesforceLogin from './components/salesForceLogin';
import FeedbackServiceFlow from './components/FeedbackServiceFlow';
import { Provider } from 'react-redux';
import FeedbackMessage from './components/FeedbackMessage';
import store from './store';
import { ToastContainer} from 'react-toastify';
import FeedbackMessageService from './components/FeedbackMessageService';
import { useEffect,useState } from 'react';
import PrivateRoute from './utils/PrivateRoute';
import $ from "jquery";
import FeedbackFormFront from './components/FeedbackFormFront';
import FeedbackFormBack from './components/FeedbackFormBack';
import NotFound from './components/NotFound';
import { HelmetProvider } from "react-helmet-async";
import Layout from './components/Layout';

function App() {
  const [isIframe, setIsIframe] = useState(false);
  useEffect(() => {
    // Check if the current window is not the top window
    if (window.self !== window.top) {
      setIsIframe(true); // Set to true if the app is inside an iframe
    }
  }, []);

  if (isIframe) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '24px',
        color: '#333',
        backgroundColor: '#f5f5f5' // Optional: Light gray background
      }}>
        <p>Refused to connect. This page cannot be displayed in an iframe.</p>
      </div>
    );
  }

  const router = createBrowserRouter([
    {
      path: '*', 
      element: <NotFound />,
    },
    {
      path: "/cankiosk",
      element: <Layout><FeedbackServiceFlow /></Layout>,
    },
    // {
    //   path: "/phone-number",
    //   element: <Mobile/>,
    // },
    // {
    //   path: "/QR",
    //   element: <QR/>,
    // },
    {
      path: "/employee-code",
      element: <Layout><EmployeeCode/></Layout>,
    },
    {
      path: "/employee-feedback",
      element: <Layout><SalesforceLogin /></Layout>,
    },
    {
      path: "/feedback-response-service",
      element: <Layout><FeedbackMessageService /></Layout>,
    },  
    {
      path: "/feedback-Form-Front",
      element: <Layout><FeedbackFormFront /></Layout>,
    },
    {
      path: "/feedback-Form-Back",
      element: <Layout><FeedbackFormBack /></Layout>,
    },
    {
      element: <PrivateRoute />,
      children: [
        {
          path: "/qr",
          element: <Layout><QR/></Layout>,
        },
        {
          path: "/phone-number",
          element: <Layout><Mobile/></Layout>,
        },
        {
          path: "/feedback",
          element: <Layout><Feedback/></Layout>,
        },
        {
          path: "/general-feedback",
          element: <Layout><BranchFeedback/></Layout>,
        },
        {
          path: "/otp-verification",
          element: <Layout><Otp/></Layout>,
        },
        {
          path: "/thank-you",
          element: <Layout><ThankYou/></Layout>,
        },
        {
          path: "/feedback-response",
          element: <Layout><FeedbackMessage /></Layout>,
        },
        // {
        //   path: "/employee-code",
        //   element: <EmployeeCode/>,</Layout>
        // },
      ]
    } 
  ])

  //    $(document).bind("contextmenu",function(e) {
  //     e.preventDefault();
  // });


  return (
    <Provider store={store}>
      <HelmetProvider>
      <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                limit={1}
                />

               <ToastContainer />
               <RouterProvider router={router} >
      </RouterProvider>
      </HelmetProvider>
     
   
  </Provider>
  );
}

export default App;
